import { AddGenericProduct } from './AddGenericProduct'

export default AddGenericProduct
